function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
document.addEventListener("DOMContentLoaded", function() {
  /* use arrow keys in pdp */
  var currentThumbnailIndex = 0;
  console.log('js LOADED');
  
  document.addEventListener('keydown', function(event) {
    let productModalElement = document.querySelector("product-modal");
    if (productModalElement) {
      if (productModalElement.hasAttribute("open")) {
        return;
      }
    }
    let liElements = document.querySelectorAll("slider-component.thumbnail-slider[id*='GalleryThumbnails-template'] ul.thumbnail-list li.thumbnail-list__item:not(.hidden)");
    let liElementsLen = liElements.length;
    if (liElements.length > 0) {
      if (event.key === 'ArrowRight') {
        currentThumbnailIndex++;
        if (currentThumbnailIndex >= liElementsLen) {
          currentThumbnailIndex = 0;
        }
      }
      if (event.key === 'ArrowLeft') {
        currentThumbnailIndex--;
        if (currentThumbnailIndex < 0) {
          currentThumbnailIndex = liElementsLen - 1;
        }
      }
      liElements[currentThumbnailIndex].querySelector("button").click();
    }
  });

  /* change icon color of accessibly app */  
  var targetNode = document.body;
  var config = {
    childList: true,
    subtree: true
  };
  var callback = function callback(mutationsList, observer) {
    var _iterator2 = _createForOfIteratorHelper(mutationsList),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var mutation = _step2.value;
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'div') {
              if (node.id === 'accessiblyAppWidgetButton') {
                let btn = document.querySelector('#accessiblyAppDialogButton');
                if (btn) {
                  let styles = btn.style.setProperty('background-color', '#4E694D', 'important');
                }
              }
            }
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});

